import axios from "axios"

const instance = axios.create({
  baseURL: "https://evangadi-forum-backend-ntqm.onrender.com/api",
});
export default instance